import React, { FC } from 'react';

import AnimationContainer from './shared/AnimationContainer';
import Header from './shared/header/Header';
import Footer from './shared/Footer';

import HeaderMobile from './shared/header/HeaderMobile';
import StepsMobile from './shared/steps/StepsMobile';

interface LayoutInterface {
  refE?: any;
}

const Layout: FC<LayoutInterface> = ({ children, refE }): JSX.Element => (
  <div ref={refE} className="layout-container">
    <HeaderMobile/>
    <div className="layout-box">
      <Header/>
      <StepsMobile/>
      <AnimationContainer>
        {children}
      </AnimationContainer>
    </div>
    <Footer/>
  </div>
);

export default Layout;
